import { cn } from "@/lib/utils";

export default function BrandMark({ className, alt = "Mayr-Technologies" }) {
  return (
    <img
      src="/brand/mayr-technologies-logo.png"
      alt={alt}
      className={cn("shrink-0 object-contain", className)}
    />
  );
}
